import { EXTERNAL_EMAIL_SEND_QUERY_KEY } from '@/hooks/pii-query-key-roots';

export const externalEmailSendKeys = {
  all: [EXTERNAL_EMAIL_SEND_QUERY_KEY] as const,
  states: () => [...externalEmailSendKeys.all, 'state'] as const,
  state: (
    organizationId: string | null | undefined,
    userId: string | null | undefined,
    draftId: string | null | undefined,
  ) =>
    [...externalEmailSendKeys.states(), organizationId ?? '', userId ?? '', draftId ?? ''] as const,
  senders: (
    organizationId: string | null | undefined,
    userId: string | null | undefined,
    mailboxId: string | null | undefined,
  ) =>
    [
      ...externalEmailSendKeys.all,
      'senders',
      organizationId ?? '',
      userId ?? '',
      mailboxId ?? '',
    ] as const,
};
